import { LogoNamesWithoutVariants } from "@sproutsocial/seeds-partner-logos";
export const partnerNames = LogoNamesWithoutVariants;
